import React from 'react'
import Container from '../Container/Index'
import Title from '../Title/Index'
import ImageTag from '../ImageTag/Index'

const Customized = ({Data, positionClass, directionRow}) => {
  return (
    <Container _parentClass={'ourMoto'} containerClass={'float-end '}>
       <div className={`col-12 float-start ${positionClass}`}>
            <div className='col-lg-10 col-12'>
            <div className={`row ${directionRow}`}>
     <div className='col-lg-6 col-12 p-0' data-aos="fade-right"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
            <ImageTag ImagePath={Data.imagePath} ImageAlt='Customed Arsus Global' ImageClass={'w-100 mb-lg-0 mb-3'}/>
          </div>
          <div className="col-lg-6 col-12 px-lg-5 px-0" data-aos="fade-left"
          data-aos-offset="100"
          data-aos-duration="1000"
          data-aos-once="true"
          data-aos-easing="ease-in-sine">
      <Title firstHeading={Data.title} secondHeading={Data.heading} subTitle={Data.descp} _class={' text-lg-start text-center mb-2'}/>  
      {Data?.points?.length > 0 && (
  <ul className='motoListitems numbers p-0 list-unstyled'>
    {Data.points.map((item, index) => (
      <li key={index} >
        <span >{String(index + 1)}</span>
        <p className='mb-0'>{item}</p>
      </li>
    ))}
  </ul>
)}
         
        </div>   
     </div>
            </div>
        </div> 
    </Container>
  )
}

export default Customized